/* ==========================================================================
   Prime Organics · vp-bp offer page engine (layout/vpo.liquid)

   One offer, read from #vpo-offer (sections/vpo-hero.liquid). Every buy button on
   the page ([data-vpo-buy]: hero CTA, offer card, lead price tag, sticky bar, the
   same controls inside the offer sheet) runs one path:
     /cart/clear.js -> /cart/add.js {subscription line + $0 gift lines} -> /checkout
   Gift lines carry _gift = the po_cart_drawer slot, so if the shopper browses the
   rest of the store the drawer sees them as already present. If the gift lines are
   refused (sold out, unpublished) the subscription is added alone: a gift must
   never block the sale.
   ========================================================================== */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var C = {};
  try { C = JSON.parse((d.getElementById('vpo-offer') || {}).textContent || '{}'); } catch (e) { C = {}; }

  function $$(sel, el) { return Array.prototype.slice.call((el || d).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- money + paint ---------- */
  function money(cents) {
    var fmt = C.money || '${{amount}}';
    var v = (Number(cents) || 0) / 100;
    var two = v.toFixed(2), noDec = String(Math.round(v));
    var withSep = function (n, sep, dec) { var p = n.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep); return p.join(dec); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withSep(noDec, ',', '.');
      if (k === 'amount_with_comma_separator') return withSep(two, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(noDec, '.', ',');
      return withSep(two, ',', '.');
    });
  }
  function ordinal(n) { var s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  function paint() {
    if (C.now) $$('[data-vpo-now]').forEach(function (el) { el.textContent = money(C.now); });
    if (C.was) $$('[data-vpo-was]').forEach(function (el) { el.textContent = money(C.was); });
    if (C.pct != null) $$('[data-vpo-pct]').forEach(function (el) { el.textContent = C.pct; });
    if (C.save) $$('[data-vpo-save]').forEach(function (el) { el.textContent = money(C.save); });
    var now = new Date();
    var mon = now.toLocaleString('en-US', { month: 'short' });
    $$('[data-vpo-date]').forEach(function (el) {
      if (el.getAttribute('data-vpo-date') === 'num') {
        el.textContent = ('0' + (now.getMonth() + 1)).slice(-2) + '/' + ('0' + now.getDate()).slice(-2) + '/' + now.getFullYear();
      } else { el.textContent = mon + ' ' + ordinal(now.getDate()); }
    });
  }

  /* ---------- cart ---------- */
  /* Native fetch, taken before po-cart-drawer.js (header-group) wraps it: that wrapper
     opens the drawer on every /cart/clear|add, which would flash it mid-redirect. This
     file loads deferred in <head>, so it always runs before the drawer's script. */
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  function post(url, body) {
    return nativeFetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body || {})
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); });
  }
  function setBusy(on) {
    $$('[data-vpo-buy]').forEach(function (b) { if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy'); });
  }
  function showErr(msg) {
    $$('[data-vpo-err]').forEach(function (el) { el.textContent = msg || C.err || 'Something went wrong. Please try again.'; el.hidden = false; });
  }
  function buy(src) {
    if (busy || !C.variant) return;
    busy = true; setBusy(true);
    $$('[data-vpo-err]').forEach(function (el) { el.hidden = true; });
    var main = { id: C.variant, quantity: 1, properties: { _vpo_src: src || 'page' } };
    if (C.plan) main.selling_plan = C.plan;
    var gifts = (C.gifts || []).map(function (g) { return { id: g.v, quantity: 1, properties: { _gift: String(g.slot || '') } }; });
    var clear = C.clear === false ? Promise.resolve() : post('/cart/clear.js');
    clear
      .then(function () { return post('/cart/add.js', { items: [main].concat(gifts) }); })
      .then(function (r) { return (r.ok || !gifts.length) ? r : post('/cart/add.js', { items: [main] }); })
      .then(function (r) {
        if (!r.ok) throw new Error((r.j && (r.j.description || r.j.message)) || '');
        try { d.dispatchEvent(new CustomEvent('vpo:added', { detail: { src: src } })); } catch (e) {}
        window.location.href = C.checkout === false ? '/cart' : '/checkout';
      })
      .catch(function (e) { busy = false; setBusy(false); showErr(e && e.message); });
  }

  /* ---------- overlays ---------- */
  var sheet = d.querySelector('[data-vpo-sheet]');
  var facts = d.querySelector('[data-vpo-factsbox]');
  var lastFocus = null;
  function lock(on) { root.classList.toggle('vpo-lock', !!on); d.dispatchEvent(new CustomEvent('vpo:overlay')); }
  function openOverlay(el) {
    if (!el) return;
    lastFocus = d.activeElement;
    el.hidden = false; lock(true);
    var x = el.querySelector('.vpo-sheet__x'); if (x) x.focus({ preventScroll: true });
  }
  function closeOverlays() {
    [sheet, facts].forEach(function (el) { if (el) el.hidden = true; });
    lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openSheet(giftIndex) {
    if (!sheet) { scrollToBuy(); return; }
    var head = sheet.querySelector('[data-vpo-sheet-gift]');
    var g = (giftIndex != null && C.ui) ? C.ui[giftIndex] : null;
    if (head) {
      if (g) {
        head.style.setProperty('--gift-bg', g.bg || '#efeaf9');
        head.innerHTML = (g.img ? '<img src="' + esc(g.img) + '" alt="">' : '') +
          '<div><span class="vpo-gift__tag">FREE GIFT' + (g.value ? ' <s>' + esc(g.value) + '</s>' : '') + '</span>' +
          '<b>' + esc(g.name) + '</b>' + (g.text ? '<p>' + esc(g.text) + '</p>' : '') + '</div>';
        head.hidden = false;
      } else { head.hidden = true; head.innerHTML = ''; }
    }
    var p = sheet.querySelector('.vpo-sheet__panel'); if (p) p.scrollTop = 0;
    openOverlay(sheet);
  }
  /* What covers the top of the viewport once scrolled: the store pill if the header is
     on (the offer bar has scrolled away by then), else the sticky offer bar. */
  function barH() {
    var h = d.querySelector('.po-head');
    if (h && h.offsetHeight) return h.offsetHeight;
    var b = d.querySelector('.vpo-bar-wrap'); return b ? b.getBoundingClientRect().height : 0;
  }
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - barH() - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  function scrollToBuy() { scrollToEl(d.querySelector('.vpo-hero__info .vpo-tier') || d.getElementById('vpo-buy')); }

  /* ---------- clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-vpo-close]'))) { e.preventDefault(); closeOverlays(); return; }
    if ((el = t.closest('[data-vpo-buy]'))) { e.preventDefault(); buy(el.getAttribute('data-src')); return; }
    if ((el = t.closest('[data-vpo-gift]'))) { e.preventDefault(); openSheet(+el.getAttribute('data-vpo-gift')); return; }
    if ((el = t.closest('[data-vpo-open]'))) { e.preventDefault(); if (deckDragged) return; openSheet(null); return; }
    if ((el = t.closest('[data-vpo-facts]'))) { e.preventDefault(); openOverlay(facts); return; }
    if ((el = t.closest('[data-vpo-togifts]'))) {
      e.preventDefault();
      var box = d.querySelector('.vpo-hero__info [data-vpo-gifts]');
      scrollToEl(box);
      if (box) { box.classList.remove('is-flash'); void box.offsetWidth; box.classList.add('is-flash'); }
      return;
    }
    if ((el = t.closest('[data-vpo-scroll]'))) { e.preventDefault(); scrollToBuy(); return; }
    if ((el = t.closest('[data-vpo-morebtn]'))) { e.preventDefault(); var w = el.closest('[data-vpo-more]'); if (w) w.classList.add('is-open'); return; }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeOverlays(); return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('[role="button"][data-vpo-buy],[role="link"][data-vpo-scroll]')) {
      e.preventDefault(); e.target.click();
    }
  });

  /* ---------- gallery ---------- */
  function gallery() {
    var gal = d.querySelector('[data-vpo-gal]'); if (!gal) return;
    var track = gal.querySelector('[data-vpo-track]');
    var thumbs = $$('[data-vpo-thumb]', gal);
    var cur = 0, raf = 0;
    function set(i) {
      cur = i;
      gal.classList.toggle('is-lead', i === 0);
      thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      var on = thumbs[i]; if (on && on.parentNode) { var p = on.parentNode; var x = on.offsetLeft - p.clientWidth / 2 + on.clientWidth / 2; p.scrollTo({ left: x, behavior: 'smooth' }); }
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) set(i); });
    }, { passive: true });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { var i = +b.getAttribute('data-vpo-thumb'); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); set(i); });
    });
  }
  function sheetGallery() {
    var g = d.querySelector('[data-vpo-sgal]'); if (!g) return;
    var tr = g.querySelector('[data-vpo-strack]'), dots = g.querySelector('[data-vpo-sdots]');
    var n = tr.children.length; if (!n || !dots) return;
    dots.innerHTML = new Array(n + 1).join('<i></i>');
    var ds = $$('i', dots);
    function mark() { var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); ds.forEach(function (x, k) { x.classList.toggle('is-on', k === i); }); }
    tr.addEventListener('scroll', function () { requestAnimationFrame(mark); }, { passive: true });
    mark();
  }

  /* ---------- swipe deck ---------- */
  var deckDragged = false;
  function decks() {
    $$('[data-vpo-deck]').forEach(function (deck) {
      var cards = $$('[data-vpo-card]', deck); if (!cards.length) return;
      var wrap = deck.closest('.vpo-deckwrap') || deck.parentNode;
      var dots = wrap.querySelector('[data-vpo-deckdots]');
      var order = cards.map(function (c, i) { return i; });
      function layout(skip) {
        order.forEach(function (ci, pos) {
          if (ci === skip) return;
          var c = cards[ci];
          c.setAttribute('data-pos', pos < 3 ? String(pos) : 'hide');
          c.setAttribute('aria-hidden', pos ? 'true' : 'false');
          $$('button', c).forEach(function (b) { b.tabIndex = pos ? -1 : 0; });
        });
        if (dots) dots.innerHTML = cards.map(function (c, i) { return '<i class="' + (i === order[0] ? 'is-on' : '') + '"></i>'; }).join('');
      }
      function next() {
        var out = order.shift(); order.push(out);
        layout(out); cards[out].setAttribute('data-pos', 'out');
        setTimeout(function () { layout(); }, 380);
      }
      function prev() { order.unshift(order.pop()); layout(); }
      var prevB = wrap.querySelector('[data-vpo-prev]'), nextB = wrap.querySelector('[data-vpo-next]');
      if (prevB) prevB.addEventListener('click', prev);
      if (nextB) nextB.addEventListener('click', next);
      var x0 = null, y0 = 0;
      deck.addEventListener('pointerdown', function (e) { x0 = e.clientX; y0 = e.clientY; deckDragged = false; });
      deck.addEventListener('pointerup', function (e) {
        if (x0 == null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          deckDragged = true; setTimeout(function () { deckDragged = false; }, 60);
          if (dx < 0) next(); else prev();
        }
      });
      deck.addEventListener('pointercancel', function () { x0 = null; });
      layout();
    });
  }

  /* ---------- tabs ---------- */
  function tabs() {
    $$('[data-vpo-tabs]').forEach(function (t) {
      var btns = $$('[data-tab]', t), panels = $$('[data-panel]', t);
      function show(name) {
        btns.forEach(function (b) { var on = b.getAttribute('data-tab') === name; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== name; });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-tab')); }); });
      var def = t.getAttribute('data-default');
      var has = btns.some(function (b) { return b.getAttribute('data-tab') === def; });
      show(has ? def : (btns[0] && btns[0].getAttribute('data-tab')));
    });
  }

  /* ---------- sticky bar ---------- */
  function sticky() {
    var bar = d.querySelector('[data-vpo-sticky]'); if (!bar) return;
    var spacer = bar.nextElementSibling && bar.nextElementSibling.classList.contains('vpo-stk-spacer') ? bar.nextElementSibling : null;
    /* the store footer now closes the page, so the spacer goes after it */
    if (spacer && d.querySelector('.poft')) d.body.appendChild(spacer);
    var after = parseFloat(bar.getAttribute('data-after')) || 0;
    var forced = false, raf = 0;
    var heroCta = d.querySelector('.vpo-hero__info [data-src="hero"]');
    function update() {
      raf = 0;
      var past = heroCta ? heroCta.getBoundingClientRect().bottom < 0 : true;
      var on = (forced || past) && !root.classList.contains('vpo-lock');
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = bar.querySelector('[data-vpo-buy]'); if (btn) btn.tabIndex = on ? 0 : -1;
      if (spacer) spacer.style.height = (on && getComputedStyle(bar).display !== 'none') ? bar.offsetHeight + 'px' : '0px';
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    if (after > 0) setTimeout(function () { forced = true; update(); }, after * 1000);
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    d.addEventListener('vpo:overlay', queue);
    update();
  }

  /* ---------- muted card videos play in view ---------- */
  function videos() {
    var vids = $$('video[data-vpo-autoplay]'); if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.play && v.play().catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function boot() { paint(); gallery(); sheetGallery(); decks(); tabs(); sticky(); videos(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
